import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { loginApi } from "@/lib/api";
import { saveAuth } from "@/lib/auth";
import { PasswordInput } from "@/components/ui-kit";

import { LOGO_URL } from "@/constants/records";
const USERS = ["MARC", "LUCIA", "HUGO", "PRIYA"];

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username) return toast.error("Tria qui ets");
    if (!password) return toast.error("Introdueix la contrasenya");
    setLoading(true);
    try {
      const data = await loginApi(username, password);
      saveAuth(data.access_token, data.user);
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Usuari o contrasenya incorrectes");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="mb-8 text-center">
          <img src={LOGO_URL} alt="Sublims" className="h-16 w-auto mx-auto" />
          <h1 className="mt-4 font-display text-3xl font-bold text-ink">
            Registres <span className="text-terracotta">APPCC</span>
          </h1>
          <p className="mt-1 text-sm text-ink-soft">Identifica't per continuar</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="rounded-2xl border border-line bg-white p-5 shadow-card">
            <div className="label-eyebrow mb-3">Qui ets?</div>
            <div className="grid grid-cols-2 gap-3">
              {USERS.map((u) => (
                <button key={u} type="button" onClick={() => setUsername(u)}
                  className={
                    "h-14 rounded-xl font-display text-base font-bold tracking-wide transition-all " +
                    (username === u ? "bg-terracotta text-white shadow-soft" : "bg-muted text-ink-soft hover:bg-cream")
                  }>
                  {u.charAt(0) + u.slice(1).toLowerCase()}
                </button>
              ))}
            </div>
          </div>
          <div className="rounded-2xl border border-line bg-white p-5 shadow-card">
            <label className="label-eyebrow mb-3 block">Contrasenya</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 z-10 -translate-y-1/2 text-ink-soft" />
              <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" autoComplete="current-password" className="pl-9" />
            </div>
          </div>
          <button type="submit" disabled={loading || !username || !password}
            className="h-14 w-full rounded-xl bg-terracotta font-display text-base font-bold text-white shadow-soft transition-all hover:bg-terracotta/90 disabled:opacity-50 disabled:cursor-not-allowed">
            {loading ? "Entrant…" : "Entrar"}
          </button>
        </form>
        <p className="mt-8 text-center text-xs text-ink-soft">Sublims · Mercat Sant Antoni · Registres APPCC</p>
      </div>
    </div>
  );
}
